import { bool, func, string } from 'prop-types';
import React, { forwardRef } from 'react';
import { FaImage } from 'react-icons/fa';

const widthsRegex = /_[0-9]{3}x$/;
const widths = [200, 300, 400, 500, 600, 700, 800];
const cdnDomain = new URL(process.env.RESOURCE_ATTACHMENTS_URL).hostname;

const ResponsiveImage = forwardRef(({
    imageUrl,
    imageAlt,
    className,
    placeholderClassName,
    mobileSize,
    desktopSize,
    onClick,
    lazyLoad,
}, ref) => {
    if (typeof imageUrl !== 'string'
        || !imageUrl.length) 
        return (<FaImage
            className={placeholderClassName ?? className}
        />);
    let srcSet = [];
    if (imageUrl.lastIndexOf('.') !== -1
        && imageUrl.includes(cdnDomain)
        && imageUrl.match(widthsRegex) === null
        && process.env.RESPONSIVE_IMAGES === 'true') {
        const extensionIdx = imageUrl.lastIndexOf('.');
        for (const width of widths) {
            const widthImageUrl =
                imageUrl.slice(0, extensionIdx)
                + `_${width}x`
                + imageUrl.slice(extensionIdx);
            srcSet.push(`${widthImageUrl} ${width}w`);
        }
    }
    return (<img
        ref={ref}
        className={className}
        alt={imageAlt ?? ''}
        onClick={onClick}
        {...(!srcSet.length) ? ({
            src: imageUrl,
        }) : ({
            sizes: '(max-width: 768px) ' + mobileSize + ',\n'
                + desktopSize,
            srcSet: srcSet.join(', '),
            'data-sizes': 'auto',
            'data-widths': JSON.stringify(widths),
            'data-srcset': srcSet.join(', '),
        })}
        {...lazyLoad === true && ({
            loading: 'lazy',
        })}
    />);
});

ResponsiveImage.propTypes = {
    imageUrl: string,
    imageAlt: string,
    className: string,
    placeholderClassName: string,
    mobileSize: string,
    desktopSize: string,
    onClick: func,
    lazyLoad: bool,
};

ResponsiveImage.defaultProps = {
    imageUrl: '',
    imageAlt: '',
    className: '',
    placeholderClassName: '',
    mobileSize: '200px',
    desktopSize: '200px',
    onClick: (e) => {},
    lazyLoad: true,
};

ResponsiveImage.displayName = 'ResponsiveImage';

export default ResponsiveImage;